import * as React from 'react';

import { IconProps } from '../Icon';

export const OrganizationOutlineIcon = ({
  width,
  color,
}: IconProps): JSX.Element => {
  const DEFAULT_WIDTH = '18';
  const DEFAULT_COLOR = 'none';

  return (
    <svg
      aria-hidden="true"
      fill={color || DEFAULT_COLOR}
      height={width || DEFAULT_WIDTH}
      viewBox="0 0 512 512"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m241 0v62h-60v60h-30v60h-120v330h450v-330h-120v-60h-30v-60h-60v-62zm-90 482h-90v-270h90zm210-270h90v270h-90zm-90 270h-30v-30h30zm60 0h-30v-60h-90v60h-30v-330h150zm-30-390v30h-90v-30z" />
        <path d="m211 182h90v30h-90z" />
        <path d="m211 242h90v30h-90z" />
        <path d="m211 302h90v30h-90z" />
        <path d="m211 362h90v30h-90z" />
        <path d="m91 242h30v30h-30z" />
        <path d="m91 302h30v30h-30z" />
        <path d="m91 362h30v30h-30z" />
        <path d="m91 422h30v30h-30z" />
        <path d="m391 242h30v30h-30z" />
        <path d="m391 302h30v30h-30z" />
        <path d="m391 362h30v30h-30z" />
        <path d="m391 422h30v30h-30z" />
      </g>
    </svg>
  );
};
